import React from 'react';
import { Redirect } from "react-router-dom";

import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import SnackBar from 'components/SnackBar'
import style from 'style/profile.css'
import Matrix from 'scripts/Matrix'
import store from '../scripts/store';
import whatsappLink from '../whatsappLink'




class Profile extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      wallet: null,
      redirectToLogin: false
    }
  }

  async componentDidMount() {
    const wallet = await store.getWallet()
    this.setState({ wallet: wallet })
  }

  onLogoutClick = async () => {
    await Matrix.logout()
    this.setState({ redirectToLogin: true })

  }

  render() {
    if (this.state.redirectToLogin) {
      return <Redirect to='/login' />
    }
    return (
      <React.Fragment>
        <Header title="طبینجا" showBackButton={false}></Header>
        <div class="profile-root">
          <div class="credit-container">
            <div class='label'>اعتبار شما</div>
            <div class='credit'>{this.state.wallet && this.state.wallet.credit} تومان</div>
            <div class="charge-credit"><span>افزایش اعتبار</span></div>
          </div>
          <div class='profile-row divider' onClick={this.onLogoutClick}>
            <MeetingRoomIcon />
            <span>  خروج</span>
          </div>
          <div className='profile-row' >
            <HelpOutlineIcon />
            <a href={whatsappLink}>  ارتباط با ما</a>
          </div>
        </div>
        <BottomNavigation selected='3' />
      </React.Fragment>
    )
  }

}

export default Profile